import styled, { css } from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { thumbnailOverflowWrapper } from '../Thumbnail/Thumbnail.tokens';

import { tokens } from './AssetDetails.tokens';

interface StyledAssetDetailsProps {
    $size?: 'medium' | 'large';
}

const typographyBase = css`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    ${styledTypography.truncate};
    letter-spacing: -0.02em;
`;

export const StyledAssetDetails = styled.div<StyledAssetDetailsProps>`
    --asset-details-gap: ${tokens.gap.medium}px;
    --asset-details-thumbnail-size: ${tokens.thumbnail.size.medium}px;
    --asset-details-thumbnail-radius: ${tokens.thumbnail.radius.medium}px;
    --asset-details-text-gap: ${tokens.textGap.medium}px;
    --asset-details-name-size: ${tokens.nameSize.medium}px;
    --asset-details-collection-size: ${tokens.collectionSize.medium}px;

    display: flex;
    gap: var(--asset-details-gap);
    align-content: center;

    ${({ $size }) =>
        $size === 'large' &&
        css`
            --asset-details-gap: ${tokens.gap.large}px;
            --asset-details-thumbnail-size: ${tokens.thumbnail.size.large}px;
            --asset-details-thumbnail-radius: ${tokens.thumbnail.radius.large}px;
            --asset-details-text-gap: ${tokens.textGap.large}px;
            --asset-details-name-size: ${tokens.nameSize.large}px;
            --asset-details-collection-size: ${tokens.collectionSize.large}px;
        `};
`;

export const ThumbnailWrapper = styled.div`
    ${thumbnailOverflowWrapper('var(--asset-details-thumbnail-radius)')};
    flex: 0 0 auto;
    width: var(--asset-details-thumbnail-size);
    height: var(--asset-details-thumbnail-size);
`;

export const TextGroup = styled.div`
    display: grid;
    align-content: center;
    text-align: left;
    gap: var(--asset-details-text-gap);
    flex: 1 1 auto;
`;

export const AssetName = styled.p`
    ${typographyBase};
    font-size: var(--asset-details-name-size);
    font-weight: 700;
`;

export const CollectionName = styled.p`
    ${typographyBase};
    font-size: var(--asset-details-collection-size);
    font-weight: 600;
    color: rgb(255, 255, 255, 0.5);
`;
